/**
 * 公共组件 — 繁體中文（對應 t('common.…')）
 */
export default {
	loading: "加載中...",
	loginModal: {
		sloganLine1: "先知命局，陪你找到人生方向",
		sloganLine2: "",
		tabPhone: "手機號登入",
		tabEmail: "郵箱登入",
		submitBtn: "登入/註冊",
		thirdLoginDivider: "使用其他方式登入",
		phonePlaceholder: "輸入您的手機號碼",
		emailPlaceholder: "輸入您的E-mail",
		codePlaceholder: "請輸入驗證碼",
		sendCode: "發送驗證碼",
		kefuHelp: "無法收到驗證碼?",
		invalidEmail: "請輸入有效的電子郵箱",
		selectAreaCode: "請選擇區號",
		captchaRequired: "請先進行人機校驗",
		codeRequired: "請輸入驗證碼",
		codeInvalid: "請輸入6位數字驗證碼",
		turnstileError: "驗證失敗，請重試",
		turnstileExpired: "驗證已過期，請重新驗證",
		turnstileUnsupported: "當前瀏覽器不支持驗證，請使用其他瀏覽器",
		bindTitle: "請輸入郵箱綁定賬號",
		bindDesc: "如有疑問，請聯繫客服",
		bindBtn: "綁定",
		kefu: "客戶支持",
		loginSuccess: "登入成功",
	},
	breadcrumb: {
		home: "首頁",
		tutor: "導師服務",
		userCenter: "個人中心",
		aiChat: "AI對話",
		chatHistory: "聊天記錄",
		onlineTest: "線上測試",
		search: "搜尋",
		searchPlaceholder: "超能力",
	},
	teacherService: {
		fahuiTitle: "法會服務",
		consultTitle: "諮詢服務",
		originalPrice: "原價{price}點數",
		finalPrice: "到手價",
		orderNow: "立即下單",
		detailTitle: "諮詢服務詳情",
		mobileDetailTitle: "服務詳情",
		solutionTitle: "解決方案",
		reviewsTitle: "用戶評價",
		recommendTitle: "推薦服務",
		freeConsult: "免費諮詢",
		freeAssistantConsult: "免費咨詢助理",
		scoreCount: "{score}({count}人諮詢)",
	},
	pcSearchModal: {
		ariaLabel: "搜尋",
		placeholder: "請輸入博主/老師暱稱搜尋",
		search: "搜尋",
		back: "返回首頁",
		clear: "清除",
		hotTitle: "熱門搜索",
		hotTeachersTitle: "熱門老師",
		loading: "加載中...",
		searching: "搜尋中...",
		noHotTeachers: "暫無熱門老師",
		emptyResults: "未找到相關內容，請換個關鍵詞試試",
		consultCount: "{count}人諮詢",
		yearsExperience: "{year}從業",
		defaultTeacherName: "老師",
		tabs: {
			teacher: "老師",
			service: "服務",
			dynamic: "動態",
			expert: "達人",
		},
		hotTags: ["感情", "婚姻", "事業"],
		dynamic: {
			more: "更多",
			comment: "評論",
			share: "分享",
		},
	},
	pcHeader: {
		nav: {
			home: "首頁",
			square: "媒體廣場",
			serviceInstitution: "服務機構",
			about: "關於我們",
		},
		downloadApp: "下載App",
		loginRegister: "登入/註冊",
		languageSwitch: "繁英切換",
		mall: {
			effectTitle: "功效分類",
			categoryTitle: "品類分類",
			effect: {
				wealth: "財運-招財進寶",
				protection: "護身-辟邪擋煞",
				relationship: "人緣-貴人桃花",
				peace: "平安-心想事成",
				career: "事業-升官發財",
			},
			category: {
				bracelet: "開運手鍊",
				hangings: "開運掛飾",
				necklace: "開運項鍊",
				ornament: "開運擺件",
				talisman: "開運靈符",
				zodiac: "生肖六合",
			},
		},
	},
	areaSelect: {
		title: "請選擇地區",
		searchPlaceholder: "請輸入地區名稱",
	},
	downloadDialog: {
		name: "先知命局App",
		desc: "該功能需要在App上使用，請打開並登入您的帳號使用",
		download: "下載App",
		open: "打開App",
	},
};
